// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"530cabd6","669":"d6003c74","714":"2fc428f1","854":"272cd1ea","889":"eeba66c0"}[chunkId] + ".chunk.js";
};